var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.56409,1.30486,-0.75127,0.900523,69.7933,-9.52039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-4.13103e-16,1.70479e-18,-1.3926,56.7694,199.064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.426,77.067L50,87.483L38.853,87.483L44.426,77.067Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,-1.12963e-16,1.06973e-16,0.835778,0.0509908,9.72081)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.723,
    y: 23.329,
    width: 11.147,
    height: 57.446
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,2.74527e-16,4.7968e-17,-0.0944481,0.0749922,25.8089)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.723,
    y: 23.329,
    width: 11.147,
    height: 57.446
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.81843566738dbf6e82e8e00efae14f1c.svg";
export { ForwardRef as ReactComponent };